import React, { useState } from "react";
import "./Signup.css";
import Button from "../Components/Common/Button";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../ThemeContext";
import { toast } from "react-toastify";

const Signup = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    agreed: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // UI Popup States
  const [showNamePopup, setShowNamePopup] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);

  // ================= SIGNUP =================
  const handleSignup = async (e) => {
    e.preventDefault();

    if (!formData.agreed) {
    toast.warning("Please accept terms and conditions");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
     toast.success("OTP sent to your email");
        setShowOtp(true); // Show OTP box
      } else {
      toast.error(data.message || "Signup failed");
      }
    } catch (err) {
      console.error(err);
   toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  // ================= VERIFY OTP =================
  const handleVerifyOtp = async () => {
    if (!otp) {
   toast.warning("Please enter OTP");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email,
          otp,
        }),
      });

      const data = await res.json();

if (res.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("userId", data.user?.id || "");
        localStorage.setItem("commonId", data.user?.common_id || "");

        // ✅ FIX 1: Save the full user object so App.jsx knows they DON'T have a workspace
        const fullUser = {
          id: data.user?.id,
          name: data.user?.name || "",
          email: data.user?.email || "",
          provider: "local",
          profile_image: data.user?.profile_image || "",
          hasWorkspace: false, // Strictly false for fresh signups
        };
        localStorage.setItem("user", JSON.stringify(fullUser));

        // Redirect to workspace creation
        navigate("/workspace", { replace: true });
      } else {
      toast.error(data.message || "Invalid OTP");
      }
    } catch (err) {
      console.error(err);
  toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  // Beautified Popup Style
  const popupStyle = {
    position: 'absolute',
    top: '-38px',
    left: '0',
    backgroundColor: '#1a73e8', // Nice Blue
    color: '#fff',
    padding: '6px 15px', // Wider padding
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '500',
    zIndex: 100,
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    pointerEvents: 'none',
    transition: 'opacity 0.2s ease'
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card" style={{ 
  backgroundColor: '#F5F5F5', 
  color: 'var(--text-main)',
  borderColor: 'var(--border-color)'
}}>
        {/* Logo */}
        <div className="logo-section text-center mt-2">
          <img
            src="/images/kinenew.svg"
            alt="KINEXAR"
            className="title-img "
            style={{ filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none' }}
          />
        </div>

        <div className="text-start signup-header-container  mt-4">
          <h2 className="signup-header mb-3  mt-3 fs-5">Sign up</h2>
        </div>

        {/* Social Buttons */}
        {!showOtp && (
          <div className="social-buttons-container mb-1">
            <button
              className="btn social-btn"
              type="button"
              onClick={() => {
                window.location.href =
                  `${process.env.REACT_APP_API_BASE_URL}/auth/google`;
              }}
            >
              Continue with Google
              <img
                src="/images/Google.svg"
                alt=""
                className="ms-2"
                height="13"
              />
            </button>

            {/* ✅ THE FIX: Added onClick routing for Microsoft exactly like Google */}
            <button 
              className="btn social-btn"
              type="button"
              onClick={() => {
                window.location.href =
                  `${process.env.REACT_APP_API_BASE_URL}/auth/microsoft`;
              }}
            >
              Continue with Microsoft
              <img
                src="/images/Microsoft.svg"
                alt=""
                className="ms-2"
                height="13"
              />
            </button>

            <button className="btn social-btn">
              Continue with Apple
              <img
                src="/images/Apple.svg"
                alt=""
                className="ms-2"
                height="13"
              />
            </button>
          </div>
        )}

        {!showOtp && (
          <div className="divider-container">
            <span className="divider-text">Or</span>
          </div>
        )}

        {/* ================= SIGNUP FORM ================= */}
        {!showOtp && (
          <form onSubmit={handleSignup}>
            <div className="text-start position-relative mb-2">
              <label className="signup-label">Full Name</label>
              
              {showNamePopup && (
                <div style={popupStyle}>
                  Max 20 characters only
                </div>
              )}

              <input
                type="text"
                className="form-control custom-input"
                placeholder="Enter Full Name"
                maxLength="20"
                onFocus={() => setShowNamePopup(true)}
                onBlur={() => setShowNamePopup(false)}
                value={formData.fullName}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    fullName: e.target.value,
                  })
                }
                required
              />
            </div>

            <div className="text-start position-relative mb-2">
              <label className="signup-label">Email</label>

              {showEmailPopup && (
                <div style={popupStyle}>
                  Max 40 characters only
                </div>
              )}

              <input
                type="email"
                className="form-control custom-input"
                placeholder="Enter Email"
                maxLength="40"
                onFocus={() => setShowEmailPopup(true)}
                onBlur={() => setShowEmailPopup(false)}
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
                required
              />
            </div>

            <div className="text-start">
              <label className="signup-label">Password</label>

              <div className="input-group position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control custom-input pe-5"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      password: e.target.value,
                    })
                  }
                  required
                />

                <span
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ cursor: "pointer", color: "#555", zIndex: 10 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={
                      showPassword
                        ? "bi bi-eye-slash-fill"
                        : "bi bi-eye-fill"
                    }
                  ></i>
                </span>
              </div>
            </div>

            <div className="form-check text-start mb-2 mt-1">
              <input
                className="form-check-input"
                type="checkbox"
                id="termsCheck"
                checked={formData.agreed}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    agreed: e.target.checked,
                  })
                }
              />

              <label
                className="form-check-label signup-label-text"
                htmlFor="termsCheck"
              >
                I agree to the <u>Privacy Policy</u> and{" "}
                <u>Terms and Conditions</u>
              </label>
            </div>

            <div className="button-container">
              <Button type="submit" className="w-100 py-2">
                {loading ? "Sending OTP..." : "Sign up"}
              </Button>
            </div>
          </form>
        )}

        {/* ================= OTP BOX ================= */}
        {showOtp && (
          <div className="otp-box text-center">
            <h4>Enter OTP</h4>
            <p>
              We sent a code to <b>{formData.email}</b>
            </p>

            <input
              type="text"
              className="form-control custom-input text-center"
              placeholder="6-digit OTP"
              maxLength={6}
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, ""))
              }
            />

            <div className="button-container mt-3">
              <Button
                type="button"
                className="w-100 py-2"
                onClick={handleVerifyOtp}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </Button>
            </div>
          </div>
        )}

        <div className="footer-logo mt-3 ">
          <img
            src="/images/monospear.svg"
            alt="Monospear"
            className="footer-img"
          />
        </div>
      </div>
    </div>
  );
};

export default Signup;